import Select from "./Select.vue";

Select.install = function(Vue) {
  Vue.component(Select.name, Select);
};
export default Select;